export default __webpack_public_path__ + "locales/sl/DeleteSelfProfileDialog.json?hash=3056c53e14ea4acfa17f7d51a87d2337";